<div class="col-auto voiceResponse-block" [class.active]="openChatBox()">
    <!-- @if (openChatBox){
        <div class="chat-close">
            <img src="/assets/images/close.svg" alt="Close" (click)="closeChatPop();">
        </div>
    } -->
    <div class="responseBlock" #scrollContainer (scroll)="onUserScroll()">
        @if (showLoadMoreBtn() && !chatLoading() && !loadingMoreHistory()) {
        <div class="load-more-btn-wrap">
            <a href="javascript:void(0)" (click)="loadingMoreChat()">
                <span>
                    <img ngSrc="assets/images/common/refresh_green.svg" alt="" width="24" height="24">
                    {{'LoadOlderChats' | translate}}
                </span>
            </a>
        </div>
        }
        @if(loadingMoreHistory()){
        @for (item of [1,2,3]; track $index) {
        <div class="chat-loader">
            <div class="l-question">
                <span class="loadingItem">
                    <i>Hey, hello, how are you?</i>
                </span>
            </div>
            <div class="l-answer">
                <span class="loadingItem me-3">
                    <i>ssss</i>
                </span>
                <span class="loadingItem">
                    <i>Hello, Sandy! I'm doing well, thank you for asking.</i>
                </span>
            </div>
        </div>
        }
        }

        @if (!chatLoading() && !loadingMoreHistory() && !loopMessages.length) {
        <div class="empty-chat">
            <div class="empty-chat__icon">
                <img ngSrc="assets/images/chat-circle-dots.svg" alt="" width="40" height="40">
            </div>
            <h5 class="empty-chat__title">{{ 'Chat is empty' | translate }}</h5>
            <p class="empty-chat__subtitle">{{ 'Be the one to break the ice' | translate }}</p>
            <div class="empty-chat__suggestions">
                @for (suggestion of chatSuggestions; track $index) {
                <button type="button" class="empty-chat__chip" [disabled]="answerProcessing()"
                    (click)="sendSuggestion(suggestion.text)">
                    {{ suggestion.label }}
                </button>
                }
            </div>
        </div>
        }

        @for(message of loopMessages; track $index; let last = $last) {
        <!-- @if (message.separation) {
                @switch (message.separation) {
                    @case('rules') {
                        <div class="chat-line">
                            <img src="/assets/images/rule-chat-icon.svg" alt="Golf">
                        </div>
                    }
                    @case ('general') {
                        <div class="chat-line general"></div>
                    }
                    @case ('search_area_tee_times') {
                        <div class="chat-line">
                            <img src="/assets/images/tee-times.svg" alt="Golf">
                        </div>
                    }
                }
            } -->
        <div class="response_row d-flex align-items-center justify-content-end mb-3">
            @if (!message.showProcessingText){
            <div class="color_box">
                {{message.question}}
            </div>
            }
        </div>
        <div class="response_row d-flex mb-3">
            <!-- @if (!message.loading) {
                    <div class="avatar w-100">
                        <img src="/assets/images/logoIcon.svg" alt="Golf">
                    </div>
                } -->

            <div class="answerBlck__contArea">
                @if (message.loading) {
                <div class="letsTalk_block processing">
                    <img src="/assets/images/chat-animation.gif" alt="processing" loading="lazy" decoding="async">
                    @if (message.showProcessingText){
                    {{message.loadingText || message.question}}
                    }
                </div>
                } @else if (!message.errored) {
                @if (message.isBlocks){
                <app-block-elements [loading]="message.answerProcessing ?? false"
                    [contentBlocks]="message.contentBlocks"
                    [interactive]="last"
                    (slotSelected)="onTeeTimeAction($event)"
                    (viewMoreSlots)="onTeeTimeAction($event)"></app-block-elements>
                } @else {
                <div [innerHTML]="message.answer | formatChat"></div>
                }
                @if(message.sources && message.sources.length > 0) {
                <source-block class="mt-2" [sources]="message.sources"
                    (openSourceModal)="openSourceModal(sourceModal, message.sources)"></source-block>
                }
                <div class="col">
                    <div class="actionBlock mt-2">
                        @if (isSignedIn()){
                            <li (click)="addReaction('dislike', $index, message.answerId ?? '')">
                                @if (message.reaction === 'dislike'){
                                <img ngSrc="assets/images/disliked.svg" alt="Dislike" width="18" height="18">
                                } @else {
                                <img ngSrc="assets/images/dislike.svg" alt="Dislike" width="18" height="16">
                                }
                            </li>
                            <li (click)="addReaction('like', $index, message.answerId ?? '')">
                                @if (message.reaction === 'like'){
                                <img ngSrc="assets/images/liked.svg" alt="Like" width="16" height="16">
                                } @else {
                                <img ngSrc="assets/images/like.svg" alt="Like" width="18" height="16">
                                }
                            </li>
                        }
                        
                        <li>
                            <a class="cursor-pointer"
                                (click)="toggleSpeaker(message, $index)">
                                @if (audioAnswerLoading() && message.loadingAudio){
                                <img src="assets/images/send-loader.svg" alt="" width="24" height="24" loading="lazy" decoding="async">
                                } @else {
                                @if(message.listening){
                                <img ngSrc="assets/images/stop.svg" alt="" class="stop" width="24" height="24">
                                } @else {
                                <img ngSrc="assets/images/sound.svg" alt="" width="18" height="16">
                                }
                                }
                            </a>
                        </li>
                    </div>
                </div>
                
                <div class="route-block">
                    @if(message.route === 'rules' && isSignedIn()){
                    <span>Ask a real rules official</span>
                    <a href="javascript:void(0)" (click)="openRuleAssistModal(ruleAssistModal, $index)">
                        <img ngSrc="assets/images/ask-blakey-icon.svg" alt="" width="24" height="24">
                        {{'Ask Blakey' | translate}}
                    </a>
                    }
                </div>
                
                }

            </div>
        </div>
        }
        <!-- letsTalk_block -->

    </div>
    <!-- [class.expand]="expandInput" -->
    <div class="voice-block expand" [class.no-courses]="!personalization.nearbyCourses().length" [class.disabled]="answerProcessing()" [class.limit-reached]="publicLimitReached() && !isSignedIn()" >
        @if (!publicLimitReached() || isSignedIn()){
            @if(recordingFinished()){
                <div class="audio-wrap">
                    <audio #audioRef [src]="audioUrl()" (pause)="onPauseOrEnd()" (ended)="onPauseOrEnd()"
                        (play)="onAudioPlay()"></audio>
                    <!-- @if(!isAudioPlaying) {
                            <button [disabled]="!recordingFinished || !audioUrl" (click)="onPlay()" class="btn bg-white play-btn">
                                <img src="/assets/images/play.svg" alt="Play">
                            </button>
                        } @else {
                            <button [disabled]="!recordingFinished || !audioUrl" (click)="onPause()" class="btn bg-white play-btn">
                                <img src="/assets/images/pause.svg" alt="Pause">
                            </button>
                        } -->
                </div>
                }
        
                @if (!hideLoadingText() && !submittingAudio()){
                    <button class="letsTalk_block none-loading">
                        <div class="d-flex">
                            {{'LetsTalk' | translate}}
                            <div class="inline-block word-carousel">
                                <span>{{'TeeTimes' | translate}}</span>
                                <span>{{'GolfRules' | translate}}</span>
                                <span>{{'GolfNews' | translate}}</span>
                                <span>{{'GolfYardage' | translate}}</span>
                            </div>
                        </div>
                    </button>
                }
        
                <div class="equalizer-box" [class.active]="showEqualizer()">
                    <canvas #equalizerCanvas width="330" height="70"></canvas>
                </div>
        
                <div class="chat-text-block" (click)="showInputBox()" [class.hide]="!hideLoadingText()">
                    
                    <textarea #chatTextarea name="chatPrompt" [ngModel]="chatPrompt()" (ngModelChange)="chatPrompt.set($event)"
                    (input)="autoResize($event)" (keydown)="handleKeyDown($event, chatTextarea)" (focus)="setOpenChatBox()"
                    (blur)="onChatInputBlur($event)"
                         [disabled]="answerProcessing()"
                         placeholder="Ask anything about golf"></textarea>
                </div>
        
                <div class="d-inline-flex align-items-center">
                    @if (isRecording()) {
                    <button (click)="closeRecording()" class="btn bg-white p-0 ms-2">
                        <img ngSrc="assets/images/close.svg" alt="Stop" width="16" height="16">
                    </button>
                    <button (click)="stopRecording()" class="btn bg-white p-0 ms-2">
                        <img ngSrc="assets/images/tick-thin.svg" alt="Close" width="24" height="24">
                    </button>
                    } @else if (submittingAudio()) {
                    <button class="btn bg-white p-0 ms-2">
                        <img ngSrc="assets/images/spinner.svg" alt="Close" class="spinning-animation" width="24" height="24">
                    </button>
                    } @else if(this.isSignedIn()) {
                    <button (click)="startRecording()" class="btn bg-white p-0 ms-2">
                        <img ngSrc="assets/images/microphone-voice.svg" alt="Microphone" width="17" height="26">
                    </button>
                    }
        
                    @if ((((this.chatPrompt() || this.audioBlob) || answerProcessing()) && !isRecording() && !this.submittingAudio()) || !this.isSignedIn()){
                    <button class="btn bg-dark p-0 ms-2 border-0 cursor-pointer" [disabled]="answerProcessing() || !chatPrompt()"
                        (click)="!answerProcessing() ? getChatResponse() : ''">
                        <img ngSrc="assets/images/upArw-voice.svg" alt="Enter" width="18" height="22">
                    </button>
                    }
                    <!-- @else {
                        <button class="btn bg-dark p-0 ms-2 border-0 cursor-pointer">
                            <img src="assets/images/white-loader.svg" alt="">
                        </button>
                    } -->
        
                    @if(!answerProcessing() && !isRecording() && !this.chatPrompt() && !this.audioBlob && !this.submittingAudio() && this.isSignedIn()) {
                    <button class="btn bg-dark p-0 ms-2 border-0 cursor-pointer" [routerLink]="['/concierge']">
                        <img ngSrc="assets/images/voiceIcon.svg" alt="Use voice mode" width="16" height="20">
                    </button>
                    }
                </div>
        } @else {
            <div class="limit-block">
                {{'Public chat limit exceeded' | translate}}
                <br> 
                {{'Please login to continue' | translate}}
                <a routerLink="login">{{'Login or signup link' | translate}}</a>
                {{'To continue chat' | translate}}
            </div>
        }
    </div>
</div>

<!-- sourcePanelBg -->
<!-- <div class="sourcePanelBg w-100" [class.active]="showSourceModal">
    <source-modal [sources]="selectedSources" (closePanel)="showSourceModal = false;"></source-modal>
</div> -->
<!-- sourcePanelBg -->

<!-- sourcePanelBg -->
<ng-template #sourceModal>
    <!-- <div class="sourcePanelBg w-100"> -->
        <source-modal [sources]="selectedSources" (closePanel)="closeSourceModal()"></source-modal>
    <!-- </div> -->
</ng-template>
<!-- sourcePanelBg -->

<ng-template #ruleAssistModal>
    <app-rule-assist-modal [ruleAssistQuestionObject]="ruleAssistQuestionObject"
        (closeModal)="closeRuleAssistModal()"></app-rule-assist-modal>
</ng-template>